<template>
  <el-container class="admin-container">
    <el-aside width="220px">
      <div class="logo">
        <span>管理后台</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        background-color="#001529"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :collapse="isCollapse"
        :unique-opened="true"
        @select="handleSelect"
        :router="true">
        <el-menu-item index="/admin/dashboard">
          <i class="el-icon-s-home menu-icon"></i>
          <span>首页</span>
        </el-menu-item>

        <el-submenu index="/admin/orders">
          <template slot="title">
            <i class="el-icon-s-order menu-icon"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item index="/admin/orders/create" class="tree-node">
            <i class="el-icon-plus sub-menu-icon"></i>
            <span class="sub-menu-text">创建订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/all" class="tree-node">
            <i class="el-icon-tickets sub-menu-icon"></i>
            <span class="sub-menu-text">所有订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/not-shipped" class="tree-node">
            <i class="el-icon-document sub-menu-icon"></i>
            <span class="sub-menu-text">未邮寄订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/in-transit" class="tree-node">
            <i class="el-icon-truck sub-menu-icon"></i>
            <span class="sub-menu-text">在途订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/testing" class="tree-node">
            <i class="el-icon-loading sub-menu-icon"></i>
            <span class="sub-menu-text">测试中订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/tested" class="tree-node">
            <i class="el-icon-check sub-menu-icon"></i>
            <span class="sub-menu-text">已测试订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/completed" class="tree-node">
            <i class="el-icon-circle-check sub-menu-icon"></i>
            <span class="sub-menu-text">已完成订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/expiring" class="tree-node">
            <i class="el-icon-time sub-menu-icon"></i>
            <span class="sub-menu-text">即将/已超期订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/dispute" class="tree-node">
            <i class="el-icon-warning sub-menu-icon"></i>
            <span class="sub-menu-text">争议/复测订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/unsettled" class="tree-node">
            <i class="el-icon-wallet sub-menu-icon"></i>
            <span class="sub-menu-text">未结算订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/return" class="tree-node">
            <i class="el-icon-back sub-menu-icon"></i>
            <span class="sub-menu-text">回寄/转寄订单</span>
          </el-menu-item>
          <el-menu-item index="/admin/orders/pending" class="tree-node" v-if="isAdminUser">
            <i class="el-icon-bell sub-menu-icon"></i>
            <span class="sub-menu-text">待处理订单</span>
          </el-menu-item>
        </el-submenu>

        <el-menu-item index="/admin/devices">
          <i class="el-icon-cpu menu-icon"></i>
          <span>仪器信息</span>
        </el-menu-item>

        <el-menu-item index="/admin/merchants">
          <i class="el-icon-s-shop menu-icon"></i>
          <span>商家管理</span>
        </el-menu-item>

        <el-menu-item index="/admin/customers">
          <i class="el-icon-user menu-icon"></i>
          <span>客户管理</span>
        </el-menu-item>

        <el-menu-item index="/admin/logistics">
          <i class="el-icon-truck menu-icon"></i>
          <span>物流公司</span>
        </el-menu-item>
        
        <el-submenu index="/admin/system" v-if="isAdminUser">
          <template slot="title">
            <i class="el-icon-setting menu-icon"></i>
            <span>系统管理</span>
          </template>
          <el-menu-item index="/admin/system/config" class="tree-node">
            <i class="el-icon-setting sub-menu-icon"></i>
            <span class="sub-menu-text">系统配置</span>
          </el-menu-item>
          <el-menu-item index="/admin/register-code" class="tree-node" v-if="isAdminUser">
            <i class="el-icon-key sub-menu-icon"></i>
            <span class="sub-menu-text">注册码管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/agreement" class="tree-node" v-if="isAdminUser">
            <i class="el-icon-document sub-menu-icon"></i>
            <span class="sub-menu-text">客户协议管理</span>
          </el-menu-item>
        </el-submenu>

        <el-menu-item index="/admin/settlement/monthly" class="top-level-menu">
          <i class="el-icon-s-finance"></i>
          <span>月结算表单</span>
        </el-menu-item>

        <el-menu-item index="/admin/change-password" class="top-level-menu">
          <i class="el-icon-setting sub-menu-icon"></i>
          <span class="sub-menu-text">修改密码</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header>
        <div class="header-left">
          <i 
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" 
            @click="toggleSidebar"
          ></i>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/admin/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.title">
              {{ currentRoute.meta.title }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.subTitle">
              {{ currentRoute.meta.subTitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              管理员 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push('/admin/change-password')">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      isCollapse: false
    }
  },
  mounted() {
    // 初始化时确保菜单项高亮
    this.enforceMenuActiveState();
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    currentRoute() {
      return this.$route
    },
    // 判断是否为管理员用户
    isAdminUser() {
      const userRole = localStorage.getItem('userRole');
      return userRole === 'admin';
    }
  },
  watch: {
    '$route'(to, from) {
      // 路由变化时保持菜单高亮
      this.$nextTick(() => {
        this.enforceMenuActiveState();
      });
    }
  },
  methods: {
    enforceMenuActiveState() {
      // 强制保持菜单项高亮
      this.$nextTick(() => {
        const activeItems = document.querySelectorAll('.el-menu-item.is-active');
        activeItems.forEach(item => {
          item.style.backgroundColor = '#1890ff';
          item.style.color = 'white';
        });
        
        // 确保所有子菜单标题正确对齐
        const submenuTitles = document.querySelectorAll('.el-submenu__title');
        submenuTitles.forEach(title => {
          // 设置flex布局
          title.style.display = 'flex';
          title.style.alignItems = 'center';
          title.style.paddingLeft = '20px';
          
          const icon = title.querySelector('i.menu-icon');
          if (icon) {
            icon.style.width = '24px';
            icon.style.textAlign = 'center';
            icon.style.marginRight = '5px';
            icon.style.display = 'inline-block';
            icon.style.height = '24px';
            icon.style.lineHeight = '24px';
          }
          
          // 确保所有span元素对齐
          const span = title.querySelector('span');
          if (span) {
            span.style.marginLeft = '5px';
            span.style.verticalAlign = 'middle';
          }
        });
        
        // 确保所有主菜单项的span元素对齐和图标对齐（排除子菜单项）
        const menuItems = document.querySelectorAll('.el-menu > .el-menu-item');
        menuItems.forEach(item => {
          // 设置flex布局
          item.style.display = 'flex';
          item.style.alignItems = 'center';
          item.style.paddingLeft = '20px';
          
          const icon = item.querySelector('i.menu-icon');
          if (icon) {
            icon.style.width = '24px';
            icon.style.textAlign = 'center';
            icon.style.marginRight = '5px';
            icon.style.display = 'inline-block';
            icon.style.height = '24px';
            icon.style.lineHeight = '24px';
          }
          
          const span = item.querySelector('span');
          if (span) {
            span.style.marginLeft = '5px';
            span.style.verticalAlign = 'middle';
          }
        });
        
        // 确保子菜单项有缩进和层次感
        const subMenuItems = document.querySelectorAll('.el-submenu .el-menu-item');
        subMenuItems.forEach(item => {
          item.style.paddingLeft = '40px';
          item.style.marginLeft = '0';
          item.style.borderLeft = 'none';
          
          // 活动状态特殊处理
          if (item.classList.contains('is-active')) {
            item.style.backgroundColor = '#1890ff';
            item.style.color = 'white';
            item.style.borderLeft = '3px solid #409EFF';
            item.style.paddingLeft = '37px';
          }
          
          // 设置子菜单文本样式
          const textSpan = item.querySelector('.sub-menu-text');
          if (textSpan) {
            textSpan.style.fontSize = '13px';
            if (item.classList.contains('is-active')) {
              textSpan.style.color = 'white';
            } else {
              textSpan.style.color = '#bfcbd9';
            }
          }
          
          // 设置子菜单图标样式
          const icon = item.querySelector('.sub-menu-icon');
          if (icon) {
            icon.style.marginRight = '8px';
            icon.style.width = '16px';
            icon.style.fontSize = '14px';
          }
          
          // 确保不显示连接线
          if (item.classList.contains('tree-node')) {
            // 查找并清除可能的伪元素样式
            const beforeElem = item.querySelector('::before');
            const afterElem = item.querySelector('::after');
            if (beforeElem) beforeElem.style.display = 'none';
            if (afterElem) afterElem.style.display = 'none';
          }
        });
        
        // 确保子菜单容器有垂直线条效果
        const subMenus = document.querySelectorAll('.el-submenu > .el-menu');
        subMenus.forEach(menu => {
          menu.style.borderLeft = '1px solid rgba(255, 255, 255, 0.08)';
          menu.style.marginLeft = '16px';
          menu.style.paddingTop = '5px';
          menu.style.paddingBottom = '5px';
        });
      });
    },
    handleSelect(index, path) {
      // 处理菜单选择事件，确保选择后保持高亮
      this.$nextTick(this.enforceMenuActiveState);
    },
    toggleSidebar() {
      this.isCollapse = !this.isCollapse
    },
    logout() {
      // 退出登录逻辑
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录状态
        // localStorage.removeItem('token')
        
        // 返回登录页
        this.$router.push('/admin/login')
        this.$message.success('已退出登录')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
/* !!! 最高优先级规则 - 强制菜单对齐 - 放在最顶部 !!! */
.el-submenu__title {
  display: flex !important;
  align-items: center !important;
  padding-left: 20px !important;
  box-sizing: border-box !important;
  justify-content: flex-start !important;
}

.el-submenu__title i {
  margin-right: 5px !important;
  width: 24px !important;
  text-align: center !important;
  vertical-align: middle !important;
  font-size: 18px !important;
}

.el-submenu__title span {
  margin-left: 5px !important;
  vertical-align: middle !important;
  display: inline-block !important;
}

/* 使用继承选择器增加权重 */
html body .el-menu .el-submenu .el-submenu__title i {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
  display: inline-block !important;
}

/* 最高优先级规则 */
body .el-menu .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  box-shadow: 0 0 0 1px #1890ff !important;
}

body .el-menu .el-submenu .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  box-shadow: 0 0 0 1px #1890ff !important;
}

/* 确保订单管理菜单对齐 */
body .el-menu .el-submenu .el-submenu__title i.menu-icon {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
  display: inline-block !important;
}

body .el-menu .el-submenu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
  margin: 4px 0 !important;
  padding-left: 20px !important;
  display: flex !important;
  align-items: center !important;
}

/* 加速菜单响应 */
.el-menu--horizontal>.el-menu-item.is-active, 
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  transition: none;
}

/* 修复点击闪烁问题 */
.el-menu-item.is-active,
.el-submenu.is-active,
.el-menu-item:hover, 
.el-menu-item:focus {
  transition: none !important;
}

/* 使用更强的选择器确保激活状态 */
.el-menu-vertical.el-menu .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
}

/* 覆盖默认的激活状态颜色 */
.el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  box-shadow: 0 0 0 1px #1890ff;
}

.admin-container {
  height: 100vh;
  overflow: hidden;
}

.el-aside {
  background-color: #001529;
  color: #fff;
  transition: width 0.3s;
  overflow-x: hidden;
  box-shadow: 2px 0 6px rgba(0,21,41,.35);
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: #002140;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}

.logo span {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  color: #fff;
}

.el-menu {
  border-right: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 220px;
}

.el-submenu__title {
  font-weight: bold;
  padding-left: 20px !important;
  position: relative;
  text-align: left;
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
  margin: 4px 0;
}

.el-submenu__title > i {
  vertical-align: middle;
  width: 24px;
  text-align: center;
}

.el-submenu__title span {
  margin-left: 5px;
  vertical-align: middle;
}

.el-submenu__title .menu-icon {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
}

.el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 4px 0;
  padding-left: 20px !important;
  text-align: left;
  display: flex;
  align-items: center;
  transition: background-color 0.3s, color 0.3s;
}

.el-menu-item-group__title {
  padding: 0;
}

.el-menu .el-menu-item {
  padding-left: 20px !important;
  user-select: none;
}

.tree-node {
  position: relative;
}

.tree-node:before, 
.tree-node:after {
  display: none !important;
}

.el-submenu .el-menu-item {
  padding-left: 50px !important;
  font-size: 13px;
  min-width: 220px;
  background-color: #000c17;
  position: relative;
  text-align: left;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

.el-submenu .el-menu-item .sub-menu-icon {
  margin-left: 0;
  margin-right: 8px;
  width: 16px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
}

.el-submenu .el-menu-item:before {
  display: none !important;
}

.el-menu > .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  box-shadow: 0 0 0 1px #1890ff;
}

.el-menu-item.is-active:hover,
.el-menu-item.is-active:focus, 
.el-menu-item.is-active:active {
  background-color: #1890ff !important;
  color: white !important;
}

.el-submenu.is-active .el-submenu__title {
  color: #409EFF !important;
}

.el-submenu__title i {
  margin-right: 5px;
}

.el-menu-item [slot="title"] {
  margin-left: 5px;
}

.el-menu-item i {
  margin-right: 5px;
  text-align: center;
  width: 24px;
  vertical-align: middle;
}

.menu-icon {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
  vertical-align: middle !important;
  display: inline-block !important;
  font-size: 18px !important;
}

.sub-menu-icon {
  margin-right: 5px;
  font-size: 14px;
}

.el-menu-item:hover, .el-menu-item:focus {
  background-color: #001528 !important;
  color: #fff !important;
}

.el-menu-item:active {
  background-color: #1890ff !important;
  color: white !important;
}

.el-submenu .el-menu-item:hover {
  background-color: #001528 !important;
}

.el-submenu .el-menu-item:active {
  background-color: #1890ff !important;
  color: white !important;
}

.el-submenu .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  box-shadow: 0 0 0 1px #1890ff;
}

.el-header {
  background-color: #fff;
  color: #333;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 15px;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left i {
  font-size: 20px;
  cursor: pointer;
  margin-right: 15px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  display: flex;
  align-items: center;
}

.el-main {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}

.el-footer {
  background-color: #fff;
  color: #999;
  text-align: center;
  line-height: 60px;
  border-top: 1px solid #e6e6e6;
}

.el-radio-button__inner, .el-submenu__title {
  text-align: left;
}

/* 统一菜单样式 */
.el-menu-item, .el-submenu__title {
  text-align: left !important;
  display: flex !important;
  align-items: center !important;
  padding-left: 20px !important;
  height: 50px !important;
  line-height: 50px !important;
  margin: 4px 0 !important;
}

/* 统一图标样式 */
.el-menu-item i, .el-submenu__title i {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
  display: inline-block !important;
}

/* 确保所有span元素对齐 */
.el-menu-item span, .el-submenu__title span {
  margin-left: 5px !important;
  vertical-align: middle !important;
  display: inline-block !important;
}

/* 强制订单管理菜单对齐 */
.el-submenu__title {
  display: flex !important;
  align-items: center !important;
  padding-left: 20px !important;
  justify-content: flex-start !important;
}

.el-submenu__title .menu-icon,
.el-menu-item .menu-icon {
  width: 24px !important;
  text-align: center !important;
  margin-right: 5px !important;
  display: inline-block !important;
  vertical-align: middle !important;
}

/* 统一所有菜单图标样式 */
.el-menu-item i, 
.el-submenu__title i {
  margin-right: 5px !important;
  width: 24px !important;
  text-align: center !important;
  display: inline-block !important;
  height: 24px !important;
  line-height: 24px !important;
  vertical-align: middle !important;
}

/* 针对Element UI默认样式的覆盖 */
.el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex !important;
  align-items: center !important;
  height: 50px !important;
}

.el-submenu [class^=el-icon-] {
  vertical-align: middle !important;
  margin-right: 5px !important;
  width: 24px !important; 
  text-align: center !important;
}

/* 增加选择器权重,覆盖Element UI样式 */
body .el-menu .el-submenu .el-submenu__title {
  padding-left: 20px !important;
  box-sizing: border-box !important;
}

body .el-menu .el-menu-item {
  padding-left: 20px !important;
  box-sizing: border-box !important;
}

/* 子菜单项缩进，显示明显的层级 */
body .el-menu .el-submenu .el-menu-item {
  padding-left: 40px !important;
  box-sizing: border-box !important;
  margin-left: 0 !important;
  border-left: none !important;
}

/* 强化子菜单的层级视觉效果 */
.el-submenu .el-menu {
  padding-left: 0 !important;
  background-color: #000c17 !important;
  border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
  margin-left: 16px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

/* 子菜单图标和文字样式 */
.el-submenu .el-menu-item .sub-menu-icon {
  margin-left: 0;
  margin-right: 8px;
  width: 16px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
}

.sub-menu-text {
  font-size: 13px;
  color: #bfcbd9;
}

/* 确保子菜单层次分明 */
.el-submenu > .el-menu:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.08);
}

/* 子菜单高亮状态 */
.el-submenu .el-menu-item.is-active {
  background-color: #1890ff !important;
  color: white !important;
  border-left: 3px solid #409EFF !important;
  padding-left: 37px !important;
}

.el-submenu .el-menu-item.is-active .sub-menu-text {
  color: white !important;
}
</style> 